import { render, staticRenderFns } from "./NumbershapeTable.vue?vue&type=template&id=24854644&scoped=true&"
import script from "./NumbershapeTable.vue?vue&type=script&lang=js&"
export * from "./NumbershapeTable.vue?vue&type=script&lang=js&"
import style0 from "./NumbershapeTable.vue?vue&type=style&index=0&id=24854644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24854644",
  null
  
)

export default component.exports